export default __webpack_public_path__ + "static/media/1.96482b71.PNG";